import * as actionTypes from "./ActionTypes";

// #region public
export const clearStateAction = (stateName) => {
  return { type: actionTypes.CLEAR_STATE, stateName };
};
export const logHistoryAction = (data) => {
  return { type: actionTypes.LOG_HISTORY, data };
};
export const changeMapViewAction = (mapState) => {
  return { type: actionTypes.CHANGE_MAP_VIEW_STATE, mapState };
};
export const addPlanIdAction = (id) => {
  return { type: actionTypes.ADD_PLAN_ID, id };
};
export const changeMapDrawerTabAction = (tab) => {
  return { type: actionTypes.MAP_DRAWER_TAB, tab };
};
export const changeLiveTrackMapDrawerTabAction = (tab) => {
  return { type: actionTypes.CHANGE_LIVETRACK_MAP_TAB, tab };
};
export const toggleWorkingButtonsAction = (state) => {
  return { type: actionTypes.STOP_WORKING_BUTTONS, state };
};
export const setCantDoEditAfterGetExternalAction = (state) => {
  return { type: actionTypes.SET_CANT_DO_EDIT_AFTER_GET_EXTERNAL, state };
};
export const changedPolygonsAction = (key, value, state) => {
  // state = add || state = remove
  return { type: actionTypes.CHANGE_POLYGONS, key, value, state };
};
export const changeMainDataForPlanResetAction = (key, data) => {
  return { type: actionTypes.CHANGE_DATA_FOR_PLAN_RESET, key, data };
};
export const toggleMenuItemAction = (key, value) => {
  return { type: actionTypes.TOGGLE_MENU_ITEM, key, value };
};
export const setMapAction = (map) => {
  return { type: actionTypes.SET_MAP, map };
};
export const screenMustFreezeAction = (freeze) => {
  return { type: actionTypes.SCREEN_MUST_FREEZE, freeze };
};
export const changeContextMenu = (key, value) => {
  return { type: actionTypes.CHANGE_CONTEXT_MENU, key, value };
};
export const toggleSocketIsListeningToMap = (state) => {
  return { type: actionTypes.TOGGLE_SOCKET_LISTENING, state };
};
export const toggleSocketLiveTackIsListeningToMap = (state) => {
  return { type: actionTypes.TOGGLE_SOCKET_LIVETACK_LISTENING, state };
};
export const findCardAction = (state, id) => {
  return { type: actionTypes.FIND_MISSION_CARD, state, id };
};
//#endregion public

// #region polygons
export const selectPolygonAction = (polygon, shouldUpdate) => {
  return { type: actionTypes.SELECT_POLYGON, polygon, shouldUpdate };
};
export const updatePolygonSettingAction = (key, value) => {
  return { type: actionTypes.UPDATE_POLYGON_SETTING, key, value };
};
export const setShowOnlyNoDriverPolygonsAction = (value) => {
  return { type: actionTypes.SET_SHOW_ONLY_NO_DRIVER_POLYGONS, value };
};
export const updatePolygonsListAction = (key, value) => {
  return { type: actionTypes.UPDATE_POLYGONS_LIST, key, value };
};
//#endregion polygons

// #region pins
export const selectPinAction = (pin, flyToPin = true) => {
  return { type: actionTypes.SELECT_PIN, pin, flyToPin };
};
export const updatePinSettingAction = (key, value) => {
  return { type: actionTypes.UPDATE_PIN_SETTING, key, value };
};
//#endregion pins

// #region liveTrack
export const updateLiveTrackAction = (data, state) => {
  return { type: actionTypes.UPDATE_LIVETRACK_DRIVERS, data, state };
};
export const nextPrevMissionAction = (nextOrPrev, currentPacketId) => {
  return { type: actionTypes.NEXT_PREV_MISSION, nextOrPrev, currentPacketId };
};
export const updateLiveTrackSingleDriverAction = (data, state) => {
  return { type: actionTypes.UPDATE_SINGLE_DRIVER_INFO, data, state };
};
export const updateLiveTrackItemsAction = (key, value) => {
  return { type: actionTypes.UPDATE_LIVETRACK_ITEMS, key, value };
};
export const DriverVehicleIsUpdatedAction = (vehicle) => {
  return { type: actionTypes.CHANGE_DRIVER_VEHICLE, vehicle };
};
export const goToDriverMissionInfoAction = (data) => {
  return { type: actionTypes.GO_TO_DRIVER_MISSION_INFO, data };
};

export const getActualRouteAction = (data) => {
  return { type: actionTypes.GET_ACTUAL_ROUTE, data };
};
export const getActualRouteSuccessAction = (res) => {
  return { type: actionTypes.GET_ACTUAL_ROUTE_SUCCESS, res };
};
export const getActualRouteFailAction = (error) => {
  return { type: actionTypes.GET_ACTUAL_ROUTE_FAIL, error };
};

export const getActualDeliveryMissionAction = (data) => {
  return { type: actionTypes.GET_ACTUAL_DELIVERY_MISSION, data };
};
export const getActualDeliveryMissionSuccessAction = (res) => {
  return { type: actionTypes.GET_ACTUAL_DELIVERY_MISSION_SUCCESS, res };
};
export const getActualDeliveryMissionFailAction = (error) => {
  return { type: actionTypes.GET_ACTUAL_DELIVERY_MISSION_FAIL, error };
};
//#endregion liveTrack

// #region fetchApi
export const getPlanInfoAction = (planId, initial = false , isInLaunchMode=false) => {
  return { type: actionTypes.GET_PLAN_INFO, planId, initial,isInLaunchMode };
};
export const getPlanInfoSuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_INFO_SUCCESS, res };
};
export const getPlanInfoFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_INFO_FAIL, error };
};

export const getPeviewPlanAction = (planId) => {
  return { type: actionTypes.GET_PLAN_PREVIEW_INFO, planId };
};
export const getPeviewPlanSuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_PREVIEW_INFO_SUCCESS, res };
};
export const getPeviewPlanFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_PREVIEW_INFO_FAIL, error };
};

export const savePeviewPlanAction = (data) => {
  return { type: actionTypes.SAVE_PLAN_PREVIEW_INFO, data };
};
export const savePeviewPlanSuccessAction = (res) => {
  return { type: actionTypes.SAVE_PLAN_PREVIEW_INFO_SUCCESS, res };
};
export const savePeviewPlanFailAction = (error) => {
  return { type: actionTypes.SAVE_PLAN_PREVIEW_INFO_FAIL, error };
};

export const getPlanLightInfoAction = (planId) => {
  return { type: actionTypes.GET_PLAN_LIGHT_INFO, planId };
};
export const getPlanLightInfoSuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_LIGHT_INFO_SUCCESS, res };
};
export const getPlanLightInfoFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_LIGHT_INFO_FAIL, error };
};

export const getPlanStatusAction = (params) => {
  return { type: actionTypes.GET_PLAN_STATUS, params };
};
export const getPlanStatusSuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_STATUS_SUCCESS, res };
};
export const getPlanStatusFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_STATUS_FAIL, error };
};

export const autoDriverAssignAction = (data) => {
  return { type: actionTypes.AUTO_DRIVER_ASSIGN, data };
};
export const autoDriverAssignSuccessAction = (res) => {
  return { type: actionTypes.AUTO_DRIVER_ASSIGN_SUCCESS, res };
};
export const autoDriverAssignFailAction = (error) => {
  return { type: actionTypes.AUTO_DRIVER_ASSIGN_FAIL, error };
};

export const getNextPrevPlanAction = (data, state) => {
  return { type: actionTypes.GET_NEXT_PREV_PLAN, data, state };
};
export const getNextPrevPlanSuccessAction = (res) => {
  return { type: actionTypes.GET_NEXT_PREV_PLAN_SUCCESS, res };
};
export const getNextPrevPlanFailAction = (error) => {
  return { type: actionTypes.GET_NEXT_PREV_PLAN_FAIL, error };
};

export const uploadLastPinAction = (data) => {
  return { type: actionTypes.UPLOAD_LAST_PIN, data };
};
export const uploadLastPinSuccessAction = (res) => {
  return { type: actionTypes.UPLOAD_LAST_PIN_SUCCESS, res };
};
export const uploadLastPinFailAction = (error) => {
  return { type: actionTypes.UPLOAD_LAST_PIN_FAIL, error };
};

export const confirmLastPinAction = (data) => {
  return { type: actionTypes.CONFIRM_LAST_PIN, data };
};
export const confirmLastPinSuccessAction = (res) => {
  return { type: actionTypes.CONFIRM_LAST_PIN_SUCCESS, res };
};
export const confirmLastPinFailAction = (error) => {
  return { type: actionTypes.CONFIRM_LAST_PIN_FAIL, error };
};

export const getRemainPinCoordAction = (data) => {
  return { type: actionTypes.GET_REMAIN_PIN_COORDS, data };
};
export const getRemainPinCoordSuccessAction = (res) => {
  return { type: actionTypes.GET_REMAIN_PIN_COORDS_SUCCESS, res };
};
export const getRemainPinCoordFailAction = (error) => {
  return { type: actionTypes.GET_REMAIN_PIN_COORDS_FAIL, error };
};

export const planResetAction = (data) => {
  return { type: actionTypes.PLAN_RESET, data };
};
export const planResetSuccessAction = (res) => {
  return { type: actionTypes.PLAN_RESET_SUCCESS, res };
};
export const planResetFailAction = (error) => {
  return { type: actionTypes.PLAN_RESET_FAIL, error };
};

export const removeDriverFromPolygonAction = (data) => {
  return { type: actionTypes.REMOVE_DRIVER_FROM_POLYGON, data };
};
export const removeDriverFromPolygonSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_DRIVER_FROM_POLYGON_SUCCESS, res };
};
export const removeDriverFromPolygonFailAction = (error) => {
  return { type: actionTypes.REMOVE_DRIVER_FROM_POLYGON_FAIL, error };
};

export const removeDistributorFromPolygonAction = (data) => {
  return { type: actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON, data };
};
export const removeDistributorFromPolygonSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON_SUCCESS, res };
};
export const removeDistributorFromPolygonFailAction = (error) => {
  return { type: actionTypes.REMOVE_DISTRIBUTOR_FROM_POLYGON_FAIL, error };
};

export const ActivationDriverAction = (data) => {
  return { type: actionTypes.DRIVER_ACTIVATION, data };
};
export const ActivationDriverSuccessAction = (res) => {
  return { type: actionTypes.DRIVER_ACTIVATION_SUCCESS, res };
};
export const ActivationDriverFailAction = (error) => {
  return { type: actionTypes.DRIVER_ACTIVATION_FAIL, error };
};

export const DispatchToDriverAction = (data) => {
  return { type: actionTypes.DISPATCH_TO_DRIVER, data };
};
export const DispatchToDriverSuccessAction = (res) => {
  return { type: actionTypes.DISPATCH_TO_DRIVER_SUCCESS, res };
};
export const DispatchToDriverFailAction = (error) => {
  return { type: actionTypes.DISPATCH_TO_DRIVER_FAIL, error };
};

export const getMissionInfoAction = (data) => {
  return { type: actionTypes.GET_MISSION_INFO, data };
};
export const getMissionInfoSuccessAction = (res) => {
  return { type: actionTypes.GET_MISSION_INFO_SUCCESS, res };
};
export const getMissionInfoFailAction = (error) => {
  return { type: actionTypes.GET_MISSION_INFO_FAIL, error };
};

export const getLiveTrackDriversAction = (data) => {
  return { type: actionTypes.GET_LIVETRACK_DRIVERS, data };
};
export const getLiveTrackDriversSuccessAction = (res) => {
  return { type: actionTypes.GET_LIVETRACK_DRIVERS_SUCCESS, res };
};
export const getLiveTrackDriversFailAction = (error) => {
  return { type: actionTypes.GET_LIVETRACK_DRIVERS_FAIL, error };
};

export const getMissionStatusExcelAction = (data) => {
  return { type: actionTypes.GET_MISSION_STATUS_EXCEL, data };
};
export const getMissionStatusExcelSuccessAction = (res) => {
  return { type: actionTypes.GET_MISSION_STATUS_EXCEL_SUCCESS, res };
};
export const getMissionStatusExcelFailAction = (error) => {
  return { type: actionTypes.GET_MISSION_STATUS_EXCEL_FAIL, error };
};

export const getDriverMissionInfoAction = (data) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO, data };
};
export const getDriverMissionInfoSuccessAction = (res) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO_SUCCESS, res };
};
export const getDriverMissionInfoFailAction = (error) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO_FAIL, error };
};

export const getDriverMissionInfoCountAction = (data) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO_COUNT, data };
};
export const getDriverMissionInfoCountSuccessAction = (res) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO_COUNT_SUCCESS, res };
};
export const getDriverMissionInfoCountFailAction = (error) => {
  return { type: actionTypes.GET_DRIVER_MISSION_INFO_COUNT_FAIL, error };
};

export const changeMissionStatusAction = (data) => {
  return { type: actionTypes.CHANGE_MISSION_STATUS, data };
};
export const changeMissionStatusSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_MISSION_STATUS_SUCCESS, res };
};
export const changeMissionStatusFailAction = (error) => {
  return { type: actionTypes.CHANGE_MISSION_STATUS_FAIL, error };
};

export const searchInLiveTrackAction = (data) => {
  return { type: actionTypes.SEARCH_IN_LIVETRACK, data };
};
export const searchInLiveTrackSuccessAction = (res) => {
  return { type: actionTypes.SEARCH_IN_LIVETRACK_SUCCESS, res };
};
export const searchInLiveTrackFailAction = (error) => {
  return { type: actionTypes.SEARCH_IN_LIVETRACK_FAIL, error };
};

export const getAllMissionPodAction = (data) => {
  return { type: actionTypes.GET_ALL_MISSION_POD, data };
};
export const getAllMissionPodSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_MISSION_POD_SUCCESS, res };
};
export const getAllMissionPodFailAction = (error) => {
  return { type: actionTypes.GET_ALL_MISSION_POD_FAIL, error };
};

export const getCityLayersAction = (data) => {
  return { type: actionTypes.GET_CITY_LAYERS, data };
};
export const getCityLayersSuccessAction = (res) => {
  return { type: actionTypes.GET_CITY_LAYERS_SUCCESS, res };
};
export const getCityLayersFailAction = (error) => {
  return { type: actionTypes.GET_CITY_LAYERS_FAIL, error };
};

export const autoAssignMicrohubsAction = (data) => {
  return { type: actionTypes.AUTO_ASSIGN_MICROHUBS, data };
};
export const autoAssignMicrohubsSuccessAction = (res) => {
  return { type: actionTypes.AUTO_ASSIGN_MICROHUBS_SUCCESS, res };
};
export const autoAssignMicrohubsFailAction = (error) => {
  return { type: actionTypes.AUTO_ASSIGN_MICROHUBS_FAIL, error };
};

export const addNewPinToPlanAction = (data) => {
  return { type: actionTypes.ADD_NEW_PIN_TO_PLAN, data };
};
export const addNewPinToPlanSuccessAction = (res) => {
  return { type: actionTypes.ADD_NEW_PIN_TO_PLAN_SUCCESS, res };
};
export const addNewPinToPlanFailAction = (error) => {
  return { type: actionTypes.ADD_NEW_PIN_TO_PLAN_FAIL, error };
};

export const EditVehicleNameAction = (data) => {
  return { type: actionTypes.EDIT_VEHICLE_NAME, data };
};
export const EditVehicleNameSuccessAction = (res, data) => {
  return { type: actionTypes.EDIT_VEHICLE_NAME_SUCCESS, res, data };
};
export const EditVehicleNameFailAction = (error) => {
  return { type: actionTypes.EDIT_VEHICLE_NAME_FAIL, error };
};

export const getLivetrackInfoAction = (data) => {
  return { type: actionTypes.GET_LIVETRACK_INFO, data };
};
export const getLivetrackInfoSuccessAction = (res, data) => {
  return { type: actionTypes.GET_LIVETRACK_INFO_SUCCESS, res, data };
};
export const getLivetrackInfoFailAction = (error) => {
  return { type: actionTypes.GET_LIVETRACK_INFO_FAIL, error };
};

export const getMissionConfirmationAction = (missionId) => {
  return { type: actionTypes.GET_MISSION_CONFIRMATION, missionId };
};
export const getMissionConfirmationSuccessAction = (res) => {
  return { type: actionTypes.GET_MISSION_CONFIRMATION_SUCCESS, res };
};
export const getMissionConfirmationFailAction = (error) => {
  return { type: actionTypes.GET_MISSION_CONFIRMATION_FAIL, error };
};

export const setMissionConfirmationAction = (data) => {
  return { type: actionTypes.SET_MISSION_CONFIRMATION, data };
};
export const setMissionConfirmationSuccessAction = (res) => {
  return { type: actionTypes.SET_MISSION_CONFIRMATION_SUCCESS, res };
};
export const setMissionConfirmationFailAction = (error) => {
  return { type: actionTypes.SET_MISSION_CONFIRMATION_FAIL, error };
};

export const changeMissionsOrderAction = (data) => {
  return { type: actionTypes.CHANGE_MISSIONS_ORDER, data };
};
export const changeMissionsOrderSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_MISSIONS_ORDER_SUCCESS, res };
};
export const changeMissionsOrderFailAction = (error) => {
  return { type: actionTypes.CHANGE_MISSIONS_ORDER_FAIL, error };
};

export const requestVehicleAction = (data) => {
  return { type: actionTypes.REQUEST_VEHICLE, data };
};
export const requestVehicleSuccessAction = (res) => {
  return { type: actionTypes.REQUEST_VEHICLE_SUCCESS, res };
};
export const requestVehicleFailAction = (error) => {
  return { type: actionTypes.REQUEST_VEHICLE_FAIL, error };
};

export const getChatMessagesAction = (data) => {
  return { type: actionTypes.GET_CHAT_MESSAGES, data };
};
export const getChatMessagesSuccessAction = (res) => {
  return { type: actionTypes.GET_CHAT_MESSAGES_SUCCESS, res };
};
export const getChatMessagesFailAction = (error) => {
  return { type: actionTypes.GET_CHAT_MESSAGES_FAIL, error };
};


export const deactiveDriversAction = (data) => {
  return { type: actionTypes.DEACTIVE_DRIVERS, data };
};
export const deactiveDriversSuccessAction = (res) => {
  return { type: actionTypes.DEACTIVE_DRIVERS_SUCCESS, res };
};
export const deactiveDriversFailAction = (error) => {
  return { type: actionTypes.DEACTIVE_DRIVERS_FAIL, error };
};

//#endregion fetchApi
